import { TFunction } from 'i18next';

export enum PassType {
  GLOBAL = 'global',
  ONE_COUNTRY = 'one-country',
}

export enum FareType {
  FIRST_CLASS = '1',
  SECOND_CLASS = '2',
}

export enum ProductType {
  CONTINUOUS = 'CONTINUOUS',
  FLEXI = 'FLEXI',
}

export const getFareOptions = (t: TFunction) => [
  { label: t('eurail.fare.first_class'), value: FareType.FIRST_CLASS },
  { label: t('eurail.fare.second_class'), value: FareType.SECOND_CLASS },
];

export const getFareLabel = (t: TFunction, fareType: FareType): string => {
  const option = getFareOptions(t).find((opt) => opt.value === fareType);
  return option ? option.label : '';
};
